import type { BasicPalette } from '@theme/theme.types'

export const GRAY_PRIMARY_VARIANTS: Partial<BasicPalette> = {
  primary2: '#636363',
  primary3: '#898989',
  primary4: '#CDCDCD',
  primary5: '#E3E3E3',
  primary6: '#F8F8F8',
  primary6_1: '#FCFCFC',
}

export const DEFAULT_LIGHT_PALETTE: BasicPalette = {
  base: '#FFFFFF',
  // rest of palette
  accent: '#CC0000',
  error: '#BC1637',
  error2: '#FEF7F5',
  error3: '#6D0738',
  info: '#5BBFE3',
  info2: '#F2FDFF',
  info3: '#C8F3FA',
  primary: '#29335C',
  primary2: '#4E5983',
  primary3: '#7E88B1',
  primary4: '#BFC5DF',
  primary5: '#E0E2ED',
  primary6: '#F7F8FB',
  primary6_1: '#FCFCFC',
  success: '#57A40F',
  success2: '#F9FFE9',
  success3: '#2F6E06',
  text: '#212121',
  text2: '#757575',
  text3: '#BDBDBD',
  warning: '#E5C302',
  warning2: '#FDF9CB',
  warning3: '#846A00',
  boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.12)',
  boxShadow2: '2px 2px 4px 0 rgba(0, 0, 0, 0.12)',
  boxShadow3: '4px 4px 8px 0 rgba(0, 0, 0, 0.12)',
}
